import { supabaseClient } from "@/lib/supabase";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "@patient-watch/ui/sonner";
import { useToastCopy } from "@/features/i18n/toastCopy";
import { diaryLabelsQueryKey } from "./selectDiaryLabels";

export interface UpdateDiaryLabelParams {
    label_id: string;
    label_name?: string;
    label_description?: string | null;
    label_url?: string | null;
    label_variant?: string | null;
}

export async function updateDiaryLabel({ label_id, ...fields }: UpdateDiaryLabelParams): Promise<void> {
    const { error } = await supabaseClient.from("diary_labels").update(fields).eq("label_id", label_id);

    if (error) throw error;
}

export function useUpdateDiaryLabel() {
    const queryClient = useQueryClient();
    const toastCopy = useToastCopy();

    return useMutation({
        mutationFn: updateDiaryLabel,
        onError: (error: Error) => {
            toast.error(error.message);
        },
        onSuccess: () => {
            toast.success(toastCopy.labelUpdated);
            void queryClient.invalidateQueries({ queryKey: diaryLabelsQueryKey });
        },
    });
}
